import React, { useState, useEffect, forwardRef } from 'react';
import { motion } from 'framer-motion';

export const Scene2 = forwardRef(function Scene2(props, ref) {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const timers = [
      setTimeout(() => setPhase(1), 500),
      setTimeout(() => setPhase(2), 1500),
    ];
    return () => timers.forEach(t => clearTimeout(t));
  }, []);

  return (
    <motion.div
      ref={ref}
      className="absolute inset-0 flex items-center justify-center bg-[#0D6B4B]"
      initial={{ clipPath: 'circle(0% at 50% 50%)' }}
      animate={{ clipPath: 'circle(150% at 50% 50%)' }}
      exit={{ opacity: 0, scale: 1.05 }}
      transition={{ duration: 1.2, ease: [0.76, 0, 0.24, 1] }}
    >
      <div className="text-center text-white">
        <motion.p
          className="text-xl md:text-2xl tracking-widest uppercase mb-4 text-[#C5A431]"
          initial={{ opacity: 0, y: 20 }}
          animate={phase >= 1 ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
        >
          Meet
        </motion.p>
        <motion.h1
          className="text-7xl md:text-9xl font-bold"
          style={{ fontFamily: 'Playfair Display, serif' }}
          initial={{ opacity: 0, scale: 0.8, filter: 'blur(20px)' }}
          animate={phase >= 2 ? { opacity: 1, scale: 1, filter: 'blur(0px)' } : { opacity: 0, scale: 0.8, filter: 'blur(20px)' }}
          transition={{ duration: 1, type: 'spring', stiffness: 100 }}
        >
          Viysr
        </motion.h1>
        <motion.p
          className="text-lg md:text-xl text-white/60 mt-6 tracking-wide"
          initial={{ opacity: 0 }}
          animate={phase >= 2 ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          San Diego's advisor marketplace
        </motion.p>
      </div>
    </motion.div>
  );
});
